import { ChatLastMessageModel } from "api";
import carChatActionTypes from "constants/carChat";
import { load } from "helpers/filtersStorage";
import { defaultConstants, defaultReducerBody, handleActions } from "helpers/redux";
import { Action } from "redux-actions";

const params = load("car-chats-params", {});

const initialState: State = {
    key: "car-chats",
    items: [],
    params: {
        start: 0,
        length: 30,
        filters: params.filters || [],
        queryFilter: params.queryFilter || {},
        customFilters: params.customFilters || {},
        preparedFilter: params.preparedFilter || {},
    },
    count: 0,
    isLoadingList: true,
    isLoadingCount: true,
    shouldUpdate: true,
};

const { READ_ALL_CAR_CHATS, READ_CAR_CHAT, TOGGLE_FAVORITE_CAR_CHAT } = carChatActionTypes;

type State = {
    key: "car-chats";
    items: ChatLastMessageModel[];
    params: {
        start: number;
        length: number;
        filters: [];
        queryFilter: {};
        customFilters: {};
        preparedFilter: {};
    };
    count: number;
    isLoadingList: boolean | {};
    isLoadingCount: boolean | {};
    shouldUpdate: boolean;
};

type ReadCarChatPayload = { chatId: number };
type TogglePayload = { id: number; isFavorite: boolean };

type CombinedPayload = ReadCarChatPayload | TogglePayload;

export default handleActions<State, CombinedPayload>(
    {
        ...defaultReducerBody<ChatLastMessageModel, State>(defaultConstants("CAR-CHATS"), initialState),
        [READ_ALL_CAR_CHATS]: (state) => ({
            ...state,
            shouldUpdate: true,
            items: state.items.map((item) => ({ ...item, unreadMessagesCount: 0 })) as ChatLastMessageModel[],
        }),
        [READ_CAR_CHAT]: (state, { payload }: Action<ReadCarChatPayload>) => ({
            ...state,
            shouldUpdate: true,
            items: state.items.map((item) => ({
                ...item,
                ...(payload.chatId === item.id ? { unreadMessagesCount: 0 } : {}),
            })) as ChatLastMessageModel[],
        }),
        [TOGGLE_FAVORITE_CAR_CHAT]: (state, { payload }: Action<TogglePayload>) => ({
            ...state,
            items: state.items.map((item) =>
                item.id === payload.id ? { ...item, isFavorite: payload.isFavorite } : item,
            ) as ChatLastMessageModel[],
        }),
    },
    initialState,
);
